export interface EmailRequest {
  emailAddress: string;
  /*
    personalisation of type {key:value} 
    key: name of variable in email template 
    value: value of template variable
  */
  personalisation?;
}
